import { http } from '../../services/apiSecurity/Http.interceptor';
import { ResponsePagination } from '../../core/interfaces/ResponsePagination';

const URL: string = '/tipoComponentes';
const URLPROCESS: string = '/filaProcessamento';
const URLREPROCESS: string = '/reprocessar';
const URLENDPROCESS: string = '/limparfila';

export const getTypeComponent = () => {
  return http.get<ResponsePagination>(URL);
};

export const getPagination = (param: string = '') => {
  return http.get<ResponsePagination>(`${URLPROCESS}${param}`);
};

export const get = (param: string = '') => {
  return http.get(`${URLPROCESS}${param}`);
};

export const reprocessar = (param: string = '') => {
  return http.get(`${URLREPROCESS}${param}`);
};

export const limparFila = (param: string = '') => {
  return http.get(`${URLENDPROCESS}${param}`);
};
